import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { Observable } from 'rxjs';

import { SchedulePartialStoreState, SCHEDULE_STATE_KEY } from '../schedule.reducer';
import { RouteSearchActions } from './route-search.action';
import * as RouteSearchSelector from './route-search.selectors';

@Injectable()
export class RouteSearchFacade {
    previousSearch$: Observable<number[]> = this.store.select(RouteSearchSelector.getPreviousSearch);

    constructor(private store: NgRedux<SchedulePartialStoreState>, private actions: RouteSearchActions) {}

    findRoute(searchKey: string): number[] {
        if (searchKey.length === 0) {
            return [];
        }

        const dictionary = this.store.getState()[SCHEDULE_STATE_KEY].routeSearch.entities;
        const words = this.store.getState()[SCHEDULE_STATE_KEY].routeSearch.ids;

        const found = words.filter((word) => word.toLowerCase().includes(searchKey.toLowerCase()));
        const resultSet = new Set<number>();

        found.forEach((word) => dictionary[word].routeIds.forEach((routeId) => resultSet.add(routeId)));

        return [...resultSet];
    }

    setPreviousSearchRoute(routeId: string) {
        this.store.dispatch(this.actions.setPreviousSearch(routeId));
    }
}
